var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 335,
    viewBox: "0 0 338 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1425_10370)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.609,
    cy: 167.453,
    r: 116.703,
    fill: "#FC8AFF",
    fillOpacity: 0.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1664 50.0252L162.453 158.857L112.192 11.5384C112.929 11.2844 113.669 11.0354 114.412 10.7916L150.703 3.28311C154.608 2.92597 158.552 2.70492 162.531 2.62476L169.169 153.648L236.223 18.28C245.821 22.8088 254.912 28.2361 263.387 34.4534L186.762 153.648L312.417 91.6581C320.48 107.194 326.145 124.174 328.921 142.109L186.762 165.802L328.105 197.773C325.977 209.261 322.659 220.331 318.283 230.85L186.762 174.484L273.838 292.293C262.407 302.189 249.603 310.541 235.749 317.024L179.816 181.429L157.531 332.281C151.185 331.964 144.932 331.287 138.795 330.272L132.936 329.016L169.398 181.429L57.3786 291.752C42.0969 278.387 29.3036 262.248 19.7844 244.12L162.453 174.484H1.11223C1.01689 172.181 0.96875 169.867 0.96875 167.541C0.96875 158.869 1.63793 150.354 2.92747 142.043L162.453 165.802L25.0659 81.6525C29.1365 74.9911 33.6664 68.641 38.6115 62.6461L39.6733 61.372C42.9938 57.4276 46.4958 53.6411 50.1664 50.0252Z",
    fill: "url(#paint0_radial_1425_10370)",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M179.526 256.302L113.828 266.009L22.625 234.503L116.37 184.015L179.526 256.302Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.81 142.304V205.971L179.523 256.302V167.587L248.81 142.304Z",
    fill: "#FBB91E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.32 142.304L107.77 212.39L179.52 256.302V165.491L105.32 142.304Z",
    fill: "#EDA32C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.32 126.728V142.304L179.52 184.015V157.251L105.32 126.728Z",
    fill: "#FBB91E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.81 126.728V142.304L179.523 184.015V157.251L248.81 126.728Z",
    fill: "#F8D841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.32 126.728L179.205 167.587L248.806 126.728L177.07 85.9995L105.32 126.728Z",
    fill: "#FFDD17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.102 226.014L142.429 233.56V148.238L130.102 142.265V226.014Z",
    fill: "#B465FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.523 149.797V234.503L220.226 226.735V143.509L209.523 149.797Z",
    fill: "#B465FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.102 142.304L177.079 116.025L220.231 143.509L209.528 149.797L177.079 129.938L142.429 148.278L130.102 142.304Z",
    fill: "#C58CFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.068 121.907C177.068 121.907 176.373 120.597 175.155 118.501C169.509 108.65 152.479 81.1263 142.418 86.0126C142.418 86.0126 134.754 96.2308 136.248 98.9032C137.741 101.576 168.264 127.278 171.474 126.741C174.684 126.204 176.373 120.623 176.373 120.623",
    fill: "#B465FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.262 98.89C136.262 98.89 173.099 123.518 171.488 126.728C169.877 129.937 135.305 110.13 136.262 98.89Z",
    fill: "#923EE9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.531 119.117C171.531 119.117 176.771 71.6417 195.583 67.5938C195.583 67.5938 206.823 72.5063 206.286 77.6678C205.749 82.8292 185.024 128.352 179.509 126.728C173.994 125.103 171.531 119.117 171.531 119.117Z",
    fill: "#B465FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.866 127.082C184.866 127.082 205.447 102.191 206.285 77.6678C206.285 77.6678 166.67 126.885 184.866 127.082Z",
    fill: "#923EE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.523 120.073C179.523 120.073 180.833 119.379 183.008 118.305C193.213 113.261 222.649 99.7941 228.282 109.41C228.282 109.41 228.99 122.156 226.265 123.558C223.54 124.96 183.938 129.453 181.502 127.226C179.065 124.999 180.833 119.366 180.833 119.366",
    fill: "#B465FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M226.259 123.61C226.259 123.61 181.941 123.61 181.496 127.226C181.05 130.841 220.823 133.488 226.259 123.61Z",
    fill: "#923EE9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1425_10370",
    x: 3.375,
    y: 0.21875,
    width: 334.469,
    height: 334.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.2656,
    result: "effect1_foregroundBlur_1425_10370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1425_10370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.945 167.453) rotate(90) scale(164.828 163.976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D66DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#D66DEC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftImg);
export default __webpack_public_path__ + "static/media/gift_img.228deb6ba4e792e081f7dbd0fb8bdf75.svg";
export { ForwardRef as ReactComponent };